<app-header></app-header>

<app-banner  [tripData]="selectedTripData"></app-banner>
<app-banner-services></app-banner-services>
<div id="trips">
  <app-popular-trips (tripSelected)="onTripSelected($event)"></app-popular-trips>
</div>

<app-journey-card></app-journey-card>
<div id="fleet">
  <app-cars-listings-data></app-cars-listings-data>
</div>

<app-reviews-testimonials></app-reviews-testimonials>
<div id="about">
  <app-about-us></app-about-us>
</div>

<app-footer></app-footer>
<app-back-to-top></app-back-to-top>
